<template>
  <div>
    <header class="home">
      <div class="headernav" :class="navBarFixed == true ? 'header' :''">
        <div class="box">
          <a class="navImg" href="/">
            <img  :src="logo" alt="云伽智能官网" title="云伽智能官网" />
          </a>
          <nav class="navlist">
            <ul>
              <li class="oneHover" style="position: relative;">
                <a href="http://iot.inyunjia.cn" target="_blank">IN+智慧平台</a>
              </li>
              <li class="twoHover" style="position: relative;">
                <router-link to="/smartProduct">智慧产品</router-link>
                <div class="hoverBox2">
                  <ul class="ulss">
                    <li class="oneWisdom">
                      <router-link :to="{path:'/smartProduct/Transportation'}">智慧出行</router-link>
                      <div class="bicyBox">
                        <ul class="twob">
                          <li class="goOut">
                            <div style="overflow: hidden;">
                              <p
                                style="font-size:0.18rem;color:#227FBF;height:0.3rem;line-height:0.3rem;float:left;margin-left:0.05rem;cursor: pointer;"
                              >交通出行</p>
                              <i
                                class="el-icon-arrow-down"
                                id="iconUp"
                                style="font-size: 0.2rem;color: #227FBF;float: left;margin-top: 0.06rem; margin-left: 1.2rem;font-weight:600;"
                              ></i>
                            </div>
                            <div class="xialaBox" style=" height: 1.4rem;">
                              <li>
                                <router-link
                                  style="margin-left:0.06rem;"
                                  :to="{path:'/smartProduct/Transportation?#Product-Smart'}"
                                >共享单车智能锁</router-link>
                              </li>
                              <!-- <li>
                              <router-link to="/smartProduct/product?id=8">共享助力车智能锁</router-link>
                            </li>
                            <li>
                              <router-link to>共享滑板车智能锁</router-link>
                              </li>-->
                            </div>
                          </li>
                        </ul>
                        <ul class="fourb">
                          <li style="float:left" class="listBox">
                            <p
                              style="font-size:0.18rem;color:#227FBF;height:0.3rem;line-height:0.3rem;float:left;margin-left:0.05rem;cursor: pointer;"
                            >车联网</p>
                            <i
                              class="el-icon-arrow-down"
                              id="iconDown"
                              style="font-size: 0.2rem;color: #227FBF;float: left;margin-top: 0.06rem; margin-left:1.2rem;font-weight: 600;"
                            ></i>
                            <div class="carBoxs">
                              <li>
                                <router-link
                                  style="margin-left:0.04rem"
                                  :to="{path:'/smartProduct/Transportation?#car-networking'}"
                                >T-BOX解决方案</router-link>
                              </li>
                              <li>
                                <router-link
                                  :to="{path:'/smartProduct/Transportation?#car-networking'}"
                                >OBD解决方案</router-link>
                              </li>
                              <li>
                                <router-link
                                  :to="{path:'/smartProduct/Transportation?#car-networking'}"
                                >环保T-BOX解决方案</router-link>
                              </li>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li class="twoSpace">
                      <router-link :to="{path:'/smartProduct/Interspace'}">智慧空间</router-link>
                      <div id="space">
                        <p>
                          <router-link
                            style="border: 0;"
                            :to="{path:'/smartProduct/Interspace?#product-in'}"
                          >IN+智慧门锁</router-link>
                        </p>
                      </div>
                    </li>
                    <li class="threeLogistics">
                      <router-link :to="{path:'/smartProduct/logistics'}">智慧物流</router-link>
                      <div id="logistics">
                        <p>
                          <router-link
                            style="border: 0;"
                            :to="{path:'/smartProduct/logistics?#product-logistics'}"
                          >智慧物流包装</router-link>
                        </p>
                      </div>
                    </li>
                    <li class="fourRetail">
                      <router-link :to="{path:'/smartProduct/Retail'}">智慧零售</router-link>
                      <div id="retail">
                        <p>
                          <router-link
                            style="border: 0;"
                            :to="{path:'/smartProduct/Retail?#product-lingshou'}"
                          >无人零售货柜</router-link>
                        </p>
                        <p>
                          <router-link
                            style="border: 0;"
                            :to="{path:'/smartProduct/Retail?#product-Super'}"
                          >商超购物车智能锁</router-link>
                        </p>
                      </div>
                    </li>
                    <li class="fiveCar">
                      <router-link :to="{path:'/smartProduct/cartronics'}">汽车电子</router-link>
                      <div id="car">
                        <p>
                          <router-link
                            style="border: 0;"
                            :to="{path:'/smartProduct/cartronics?#gasoline'}"
                          >汽油车智能诊断</router-link>
                        </p>
                        <p>
                          <router-link
                            style="border: 0;"
                            :to="{path:'/smartProduct/cartronics?#diesel'}"
                          >柴油车智能诊断</router-link>
                        </p>
                         <p>
                          <router-link
                            style="border: 0;"
                            :to="{path:'/smartProduct/cartronics?#locksmith'}"
                          >锁匠系列</router-link>
                        </p>
                         <p>
                          <router-link
                            style="border: 0;"
                            :to="{path:'/smartProduct/cartronics?#tire-pressure'}"
                          >胎压诊断系列</router-link>
                        </p>
                         <p>
                          <router-link
                            style="border: 0;"
                            :to="{path:'/smartProduct/cartronics?#other-diagnose'}"
                          >其他诊断及配件</router-link>
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="threeHover" style="position: relative;">
                <router-link to="/classicCase">经典案例</router-link>
                <div class="hoverBox3">
                  <ul>
                    <li>
                      <router-link :to="{path:'/classicCase?#tab1'}">共享出行</router-link>
                    </li>
                    <li>
                      <router-link :to="{path:'/classicCase?#tab2'}">车联网</router-link>
                    </li>
                    <li>
                      <router-link :to="{path:'/classicCase?#tab3'}">科技行业</router-link>
                    </li>
                    <li>
                      <router-link :to="{path:'/classicCase?#tab4'}">互联网行业</router-link>
                    </li>
                    <li>
                      <router-link :to="{path:'/classicCase?#tab5'}">零售行业</router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="fourHover" style="position: relative;">
                <router-link to="/cooperation">商务合作</router-link>
              </li>
              <li class="fiveHover" style="position: relative;">
                <router-link to="/news">新闻动态</router-link>
                <div class="dynamic">
                  <ul>
                    <li>
                      <router-link :to="{path:'/news/media?#news-title'}">媒体报道</router-link>
                    </li>
                    <li>
                      <router-link :to="{path:'/news/companyNews?#news-title'}">公司动态</router-link>
                    </li>
                    <li>
                      <router-link :to="{path:'/news/Information?#news-title'}">行业资讯</router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="sixHover" style="position: relative;">
                <router-link to="/aboutUs">关于我们</router-link>
                <div class="aboutTheUs">
                  <ul>
                    <li>
                      <router-link :to="{path:'/aboutUs?#bot5'}">企业简介</router-link>
                    </li>
                    <li>
                      <router-link :to="{path:'/aboutUs?#bot6'}">企业文化</router-link>
                    </li>
                    <li>
                      <router-link :to="{path:'/aboutUs?#bot8'}">发展历程</router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <router-link to="/joinUs">加入我们</router-link>
              </li>
              <li>
                <router-link to="/contactUs">联系我们</router-link>
              </li>
            </ul>
          </nav>
          <div class="lastNav">
            <span @click="changeType('zh')">
              <i class="iconfont icon-diqiu" style="margin-right:.05rem;"></i>中
            </span>
            <el-divider direction="vertical"></el-divider>
            <span @click="changeType('en')">EN</span>
          </div>
        </div>
      </div>
    </header>
    <div class="mobile-header">
      <div class="m-nav">
        <a href="/">
        <img src="../../assets/mobileImg/m-logo.png" />
      </a>
      <i @click="mobileNav" class="iconfont icon-NMStubiao-"></i>
      </div>

      <div v-if="muntBox" class="phone_ment_box">
        <div class="close_box"></div>
        <div class="inner">
          <i @click="closeBox" class="iconfont icon-guanbi"></i>
          <div class="menu_list">
              <template v-for="(item,index) in menuList">
                <div class="block" :key="index">
                  <router-link :to="item.name" active-class="active">
                    <span>{{item.title}}</span>
                    <div class="select_icon" v-if="item.children" @click.prevent="Openselect">
                      <i :class="selectBox ? 'iconfont icon-shang': 'iconfont icon-xia'"></i>
                    </div>
                  </router-link>
                  <div class="select_box" v-if="selectBox && item.children">
                    <template v-for="(list,index) in item.children">
                      <a :href="list.name" :key="index" class="ele">
                        {{list.title}}
                        <div v-if="list.child && list.show==0" @click.prevent="selectChild" class="select_icon">
                          <i :class="selectChildBox? 'iconfont icon-shang': 'iconfont icon-xia'"></i>
                        </div>
                        <div v-if="list.child && list.show==1" @click.prevent="selectchange" class="select_icon">
                          <i :class="ChildBox? 'iconfont icon-shang': 'iconfont icon-xia'"></i>
                        </div>
                        <div v-if="list.child && list.show==2" @click.prevent="selectCart" class="select_icon">
                          <i :class="CartBox? 'iconfont icon-shang': 'iconfont icon-xia'"></i>
                        </div>
                      </a>
                      <div v-if="selectChildBox && list.child && list.show==0"  class="selectchild_box" :key="list.title">
                        <template v-for="(each,index) in list.child">
                          <a :key="index" :href="each.name" class="child_ele">
                            {{each.title}}
                          </a>
                        </template>
                      </div>
                      <div v-if="ChildBox && list.child && list.show==1"  class="selectchild_box" :key="list.title">
                        <template v-for="(each,index) in list.child">
                          <a :key="index" :href="each.name" class="child_ele">
                            {{each.title}}
                          </a>
                        </template>
                      </div>
                      <div v-if="CartBox && list.child && list.show==2"  class="selectchild_box" :key="list.title">
                        <template v-for="(each,index) in list.child">
                          <a :key="index" :href="each.name" class="child_ele">
                            {{each.title}}
                          </a>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
              <a>
                <div class="block">
                  <div class="block_ele">
                    <div class="flex_a">
                      <span class="ele_box">English | 中文</span>
                    </div>
                  </div>
                </div>
              </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      navBarFixed: false,
      muntBox:false,
      selectBox:false,
      selectChildBox:false,
      CartBox:false,
      ChildBox:false,
      logo:require('../../assets/image/logo.png'),
      logo1:require('../../assets/image/logo.png'),
      logo2:require('../../assets/image/logo1.png'),
      menuList:[
        {title:'智慧产品',name:'/smartProduct',children:[
          {title:'智慧出行',child:[
            {title:'交通出行',name:'/smartProduct/Transportation?#Product-Travel'},
            {title:'车联网',name:'/smartProduct/Transportation?#Product-car'}
          ],show:0},
          {title:'智慧空间',name:'/smartProduct/Interspace'},
          {title:'智慧物流',name:'/smartProduct/Logistics'},
          {title:'智慧零售',child:[
             {title:'无人零售货柜',name:'/smartProduct/Retail?#product-retail'},
             {title:'商超购物车智能锁',name:'/smartProduct/Retail?#product-super'}
          ],show:1},
          {title:'汽车电子',name:'/smartProduct/cartronics',child:[
            {title:'汽油车智能诊断',name:'/smartProduct/cartronics?#Product-gasoline'},
            {title:'柴油车智能诊断',name:'/smartProduct/cartronics?#Product-diesel'},
            {title:'锁匠系列',name:'/smartProduct/cartronics?#Product-locksmith'},
            {title:'胎压诊断系列',name:'/smartProduct/cartronics?#Product-tire'},
            {title:'其他诊断及配件',name:'/smartProduct/cartronics?#Product-other'}
          ],show:2}
        ]},
        {title:'经典案例',name:'/classicCase'},
        {title:'商务合作',name:'/cooperation'},
        {title:'新闻动态',name:'/news'},
        {title:'关于我们',name:'/aboutUs'},
        {title:'加入我们',name:'/joinUs'},
        {title:'联系我们',name:'/contactUs'}
      ]
    };
  },
  computed: {},
  mounted() {
    window.addEventListener("scroll", this.watchScroll);
  },
  methods: {
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 78) {
        this.navBarFixed = true;
        this.logo = this.logo2;
      } else {
        this.navBarFixed = false;
        this.logo = this.logo1;
      }
    },
    changeType(type) {
      //  const loading = this.$loading({
      //   lock: true,
      //   text: this.$t("element.loadingText"),
      // });
      // setTimeout(function() {
      //   loading.close();
      // }, 600);
      // localStorage.setItem("locale", type);
      // this.$i18n.locale = localStorage.getItem("locale");
    },
    mobileNav(){
      this.muntBox = true;
    },
    closeBox(){
      this.muntBox = false;
    },
    Openselect(){
      this.selectBox = !this.selectBox;
    },
    selectChild(){
      this.selectChildBox = !this.selectChildBox;
    },
    selectchange(){
       this.ChildBox = !this.ChildBox;
    },
    selectCart(){
      this.CartBox = !this.CartBox;
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 767px) {
  .home {
    display: none;
  }
}
.mobile-header {
  display: none;
}
.m-nav{
  width: 100%;
  padding: 0 10px;
  height: 50px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999999;
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(27,31,64,.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  box-sizing: border-box;
   a{
    width: 99px;
    height: 31px;
    display: flex;
    img {
      width: 100%;
      height: 100%;
    }
  }
  i{
    color: #0982D6;
    font-size: 22px;
  }
}
.phone_ment_box{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,.5);
    z-index: 999999999999;
    .close_box{
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: calc(100% - 160px);
    }
    .inner{
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 160px;
      background: #227FBF;
      padding-top: 37px;
      overflow-y: scroll;
      overflow-x: hidden;
      i{
        font-size: 15px;
        color: #fff;
        position: absolute;
        top: 11px;
        right: 20px;
      }
      .menu_list{
        box-sizing: border-box;
        .block{
          position: relative;
          a{
            display: block;
            font-size: 13px;
            color: #fff;
            height: 45px;
            line-height: 45px;
            position: relative;
            padding-right: 20px;
            padding-left: 10px;
          }
          .active{
            background: #3d3d46;
          }
          .select_icon{
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            width: 80px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding-right: 10px;
            i{
              height: auto;
              position: absolute;
              top: 0;
            }
          }
          .select_box{
            background: #1C78B7;
            .ele{
              line-height: 43px;
              display: block;
              font-size: 13px;
              color: #fff;
              letter-spacing: 0;
              padding-left: 20px;
            }
            .selectchild_box{
              .child_ele{
                line-height: 43px;
                display: block;
                font-size: 12px;
                color: #fff;
                letter-spacing: 0;
                padding-left: 40px;
              }
            }
          }
        }
        .block_ele{
          display: block;
          font-size: 13px;
          color: #fff;
          height: 45px;
          line-height: 45px;
          position: relative;
          padding-right: 20px;
          padding-left: 10px;
          .flex_a{
            display: flex;
            align-items: center;
            .ele_box{
              font-size: 12px;
              color: #fff;
              height: 45px;
              line-height: 45px;
            }
          }
        }
      }
    }
}
.active{
  background-color: #3d3d46;
}
@media screen and (max-width: 767px) {
  .mobile-header {
    display: block;
  }
}
.home {
  width: 100%;
  height: 100%;
  position: relative;
  .header {
    background: #fff;
    box-shadow:0px 6px 15px rgba(219,219,219,0.4);
    a{
      color:#000 !important;
    }
    .lastNav{
      color: #000 !important;
    }
  }
  .headernav {
    width: 100%;
    z-index: 100000;
    position: fixed;
    top: 0;
    .box {
      margin: auto;
      width: 87%;
      height: 0.78rem;
      color: #fff;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      .navImg {
        display: block;
        float: left;
        width: 14%;
        height: 0.5rem;
        line-height: 0.5rem;
        cursor: pointer;
        img {
          width: 1.51rem;
          height: 100%;
        }
      }
      .navlist {
        width: 76%;
        height: 0.7rem;
        float: left;
        li {
          float: left;
          height: 0.78rem;
          white-space: nowrap;
          line-height: 0.78rem;
          text-overflow: ellipsis;
          padding: 0 2.7%;
          a {
            display: block;
            height: 0.74rem;
            float: left;
            font-size: 0.2rem;
            font-weight: 400;
            text-decoration: none;
            color: rgba(255, 255, 255, 1);
          }
        }
        li:hover a {
          border-bottom: 0.046rem solid #fff;
        }
        .hoverBox2 {
          width: 4.88rem;
          height: 0rem;
          opacity: 0;
          background: #fff;
          padding: 0 0.27rem;
          box-sizing: border-box;
          text-align: center;
          margin-top: -0.01rem;
          position: absolute;
          z-index: 999;
          left: -0.6rem;
          top: 0.8rem;
          transition-property: opacity;
          transition-duration: 1s;
          transition: 0.5s;
          overflow: hidden;
          box-shadow: 0 0 0.05rem #d9d9d9;
          .ulss {
            width: 1.56rem;
            height: 4.4rem;
            border-right: 0.04rem solid #efefef;
            padding-top: 0.2rem;
            box-sizing: border-box;
            .bicyBox {
              position: absolute;
              left: 1.8rem;
              height: 5.45rem;
              width: 3.1rem;
              top: 0rem;
              padding: 0.44rem 0.3rem;
              box-sizing: border-box;
              display: none;
              .twob {
                border: 0;
                text-align: left;
                overflow: hidden;
                .xialaBox {
                  display: none;
                }
                .goOut:hover .xialaBox {
                  height: 1.4rem;
                  display: block;
                }
                #iconUp {
                  transition: all 0.2s ease-in-out;
                }
                .goOut:hover #iconUp {
                  transform: rotate(180deg);
                }
                li {
                  height: 0.55rem;
                  width: 2.48rem;
                }
                li a {
                  font-size: 0.16rem;
                  color: rgba(102, 102, 102, 1);
                  margin-top: 0.2rem;
                  border-right: 0;
                }
                li a:hover {
                  color: #227FBF;
                  border-right: 0;
                }
              }
              .fourb {
                border: 0;
                height: 0.8rem;
                text-align: left;
                margin-top: 0.1rem;
                .carBoxs {
                  display: none;
                  height: 0.8rem;
                }
                .listBox:hover .carBoxs {
                  display: block;
                }
                #iconDown {
                  transition: all 0.2s ease-in-out;
                }
                .listBox:hover #iconDown {
                  transform: rotate(180deg);
                }
                li {
                  height: 0.5rem;
                  width: 2.48rem;
                  float: left;
                }
                li a {
                  font-size: 0.16rem;
                  color: rgba(102, 102, 102, 1);
                  margin-top: 0.2rem;
                  border-right: 0;
                }
                li a:hover {
                  color: #227FBF;
                }
              }
            }
            .oneWisdom:hover .bicyBox {
              display: block;
            }
            .oneWisdom:hover a {
              color: #227FBF;
              border-right: 0.04rem solid #227FBF;
            }
            #space {
              position: absolute;
              left: 1.8rem;
              height: 5.45rem;
              width: 3.1rem;
              top: 0rem;
              padding: 0.2rem 0.3rem;
              box-sizing: border-box;
              display: none;
              p a {
                font-size: 0.18rem;
                font-weight: 500;
                color: rgba(102, 102, 102, 1);
              }
              p a:hover {
                color: #227FBF;
              }
            }
            .twoSpace:hover #space {
              display: block;
            }
            .twoSpace:hover a {
              color: #227FBF;
              border-right: 0.04rem solid #227FBF;
            }
            #logistics {
              position: absolute;
              left: 1.8rem;
              height: 5.45rem;
              width: 3.1rem;
              top: 0rem;
              padding: 0.2rem 0.3rem;
              box-sizing: border-box;
              display: none;
              p a {
                font-size: 0.18rem;
                font-weight: 500;
                color: rgba(102, 102, 102, 1);
              }
              p a:hover {
                color: #227FBF;
              }
            }
            .threeLogistics:hover #logistics {
              display: block;
            }
            .threeLogistics:hover a {
              color: #227FBF;
              border-right: 0.04rem solid #227FBF;
            }
            #retail {
              position: absolute;
              left: 1.8rem;
              height: 5.45rem;
              width: 3.1rem;
              top: 0rem;
              padding: 0.2rem 0.3rem;
              box-sizing: border-box;
              display: none;
              p {
                text-align: left;
                a {
                  font-size: 0.18rem;
                  font-weight: 500;
                  color: rgba(102, 102, 102, 1);
                  border-right: 0;
                }
              }
              p a:hover {
                color: #227FBF;
                border: 0;
              }
            }

            .fourRetail:hover #retail {
              display: block;
            }
            .fourRetail:hover a {
              color: #227FBF;
              border-right: 0.04rem solid #227FBF;
            }
            #car {
              position: absolute;
              left: 1.8rem;
              height: 5.45rem;
              width: 3.1rem;
              top: 0rem;
              padding: 0.2rem 0.3rem;
              box-sizing: border-box;
              display: none;
              p {
                text-align: left;
                a {
                  font-size: 0.18rem;
                  font-weight: 500;
                  color: rgba(102, 102, 102, 1);
                  border-right: 0;
                }
              }
              p a:hover {
                color: #227FBF;
                border: 0;
              }
            }
            .fiveCar:hover #car {
              display: block;
            }
            .fiveCar:hover a {
              color: #227FBF;
              border-right: 0.04rem solid #227FBF;
            }
            li {
              float: none;
              width: 1.52rem;
              a {
                font-size: 0.18rem;
                font-weight: 500;
                color: rgba(102, 102, 102, 1);
                line-height: 0.36rem;
                display: block;
                width: 1.46rem;
                height: 0.36rem;
                margin-top: 0.2rem;
              }
            }
          }
        }
        .twoHover:hover .hoverBox2 {
          opacity: 1;
          height: 5rem;
        }
        .hoverBox3 {
          height: 0rem;
          background: #fff;
          padding: 0 0.67rem;
          box-sizing: border-box;
          text-align: center;
          position: absolute;
          margin-top: -0.01rem;
          z-index: 999;
          left: -0.5rem;
          top: 0.8rem;
          transition-property: opacity;
          transition-duration: 1s;
          opacity: 0;
          overflow: hidden;
          transition: all 0.5s;
          box-shadow: 0 0 0.05rem #d9d9d9;
          ul li {
            text-align: left;
            a {
              font-size: 0.18rem;
              font-weight: 500;
              color: rgba(102, 102, 102, 1);
              line-height: 0.6rem;
              display: block;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              transition: color 0.3s;
            }
          }

          li a:hover {
            color: #227FBF;
          }
        }
        .threeHover:hover .hoverBox3 {
          opacity: 1;
          height: 3.9rem;
        }
        .dynamic {
          height: 0rem;
          background: #fff;
          padding: 0 0.67rem;
          margin-top: -0.01rem;
          box-sizing: border-box;
          text-align: center;
          position: absolute;
          z-index: 999;
          left: -0.4rem;
          top: 0.8rem;
          transition-property: opacity;
          transition-duration: 1s;
          transition: 0.5s;
          opacity: 0;
          overflow: hidden;
          box-shadow: 0 0 0.05rem #d9d9d9;
          ul li {
            text-align: left;
            a {
              font-size: 0.18rem;
              font-weight: 500;
              color: rgba(102, 102, 102, 1);
              line-height: 0.6rem;
              display: block;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              transition: color 0.3s;
            }
          }
          li a:hover {
            color: #227FBF;
          }
        }
        .fiveHover:hover .dynamic {
          opacity: 1;
          height: 3rem;
        }
        .aboutTheUs {
          height: 0rem;
          background: #fff;
          padding: 0 0.67rem;
          box-sizing: border-box;
          text-align: center;
          margin-top: -0.01rem;
          position: absolute;
          z-index: 999;
          left: -0.45rem;
          top: 0.8rem;
          transition-property: opacity;
          transition-duration: 1s;
          transition: 0.5s;
          opacity: 0;
          overflow: hidden;
          box-shadow: 0 0 0.05rem #d9d9d9;
          ul li {
            text-align: left;
            a {
              font-size: 0.18rem;
              font-weight: 500;
              color: rgba(102, 102, 102, 1);
              line-height: 0.6rem;
              display: block;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              transition: color 0.3s;
            }
          }
          li a:hover {
            color: #227FBF;
          }
        }
        .sixHover:hover .aboutTheUs {
          opacity: 1;
          height: 3rem;
        }
        li:nth-of-type(1) {
          padding-left: 0;
        }
        li:last-of-type {
          padding-right: 0;
        }
      }

      .lastNav {
        float: right;
        width: 9%;
        line-height: 0.78rem;
        font-size: 0.2rem;
        cursor: pointer;
        color: #fff;
        text-align: right;
        span {
          font-size: 0.2rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/header.vue